import { Link } from "react-router-dom";
import { IMAGES } from "@/data/images";

export const Logo = ({ suffix, to = "/" }) => (
  <Link to={to} data-testid="logo-link" className="flex items-center gap-2.5 group">
    <img
      src={IMAGES.logo}
      alt="Polvo"
      className="h-8 w-8 object-contain transition-transform duration-500 group-hover:rotate-[25deg]"
    />
    <span className="font-syne font-bold text-lg tracking-tight text-white">
      POLVO
      {suffix && <span className="text-brand-cyan ml-1.5 font-normal">{suffix}</span>}
    </span>
  </Link>
);
